const state = {
  authenticated: !!localStorage.getItem('tokenSalmon'),
  signupResultCode: null,
  isShowModal: false,
  isShowMaintenanceModal: false,
  modalMessage: null,
  modalWidth: 400
}

const mutations = {
  doAuthenticated (state, success) {
    state.authenticated = success
  },
  saveResultCode (state, code) {
    state.signupResultCode = code
  },
  toggleModal (state, data = {}) {
    state.isShowModal = data.show || false
    state.modalMessage = data.show ? data.message : null
    state.modalWidth = data.modalWidth ? data.modalWidth : 400
  },
  toggleMaintenanceModal (state, data = {}) {
    state.isShowMaintenanceModal = data.show || false
  }
}

// getters
const getters = {
  isAuthenticated: state => state.authenticated,
  getResultCode: state => state.signupResultCode,
  getIsShowModal: state => state.isShowModal,
  getIsShowMaintenanceModal: state => state.isShowMaintenanceModal,
  getModalMessage: state => state.modalMessage,
  getModalWidth: state => state.modalWidth
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js